import type { BucketsType } from "@shared/graphql.apollo";

import { useMemo } from "react";
import { useBasketByLimit } from "../useBasketByLimit/useBasketByLimit";
import { useBasketByType } from "../useBasketByType/useBasketByType";

export const useBasketBuckets = (): BucketsType => {
  const sortedBasket = useBasketByType();
  const basketByLimit = useBasketByLimit(sortedBasket);

  return useMemo(
    () => ({ ...sortedBasket, ...basketByLimit }),
    [sortedBasket, basketByLimit]
  );
};
